import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// project imports
import { useGetMeQuery } from './authApi';
import { loggedOut, profileLoaded, selectAccessToken } from './authSlice';

// ==============================|| AUTH - BOOTSTRAP ||============================== //
// Background-only: fires GET /auth/me whenever there's a token but no profile yet
// (fresh login, or a page reload with a persisted session), and syncs the result into
// the auth slice. Always renders children immediately - it never unmounts the router;
// RequireAuth/GuestGuard are the ones that show a Loader while status is 'loading',
// as part of the normal route tree.

export default function AuthBootstrap({ children }) {
  const dispatch = useDispatch();
  const accessToken = useSelector(selectAccessToken);

  const { data, error } = useGetMeQuery(undefined, { skip: !accessToken });

  useEffect(() => {
    if (data) {
      dispatch(profileLoaded(data));
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (error) {
      dispatch(loggedOut());
    }
  }, [error, dispatch]);

  return children;
}
